import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  id: "notification-menu-popover-dropdown",
  class: "notification-menu-container"
}
const _hoisted_2 = {
  key: 0,
  class: "notification-menu-container__popover-dropdown popover-dropdown"
}
const _hoisted_3 = { class: "popover-dropdown__content" }
const _hoisted_4 = { class: "popover-dropdown__body dropdown-body" }
const _hoisted_5 = { class: "dropdown-body__content-item" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 1,
  class: "dropdown-body__content-item-container"
}
const _hoisted_8 = { class: "dropdown-body__content-item" }

import SvgLoader from '@/utils/SvgLoader.vue';
import { onMounted, onUnmounted, reactive } from 'vue';
import { i18n } from '@/i18n';
import { NotificationMenuItem } from './interfaces/notificationMenuItem';


export default /*@__PURE__*/_defineComponent({
  __name: 'NotificationMenu',
  props: {
    notificationItems: {}
  },
  emits: ["deleteTargetRequestId"],
  setup(__props: any, { emit: __emit }) {

const t = i18n.t;

const emits = __emit;

const props = __props;

const state = reactive({
  isOpen: false,
});

const toggleDropDown = () => {
  state.isOpen = !state.isOpen;
};

/**
 * ドロップダウンを閉じる
 * @param event - クリックイベント
 */
const closeDropdown = (event: MouseEvent) => {
  if (!(event.target as Element).closest(`#notification-menu-popover-dropdown`)) {
    state.isOpen = false;
  }
};

const onClickMenuItem = (item: NotificationMenuItem) => {
  emits('deleteTargetRequestId', item.requestId);
};

onMounted(() => {
  document.addEventListener('click', closeDropdown);
});

onUnmounted(() => {
  document.removeEventListener('click', closeDropdown);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "notification-menu-container__icon",
      onClick: toggleDropDown
    }, [
      _createVNode(SvgLoader, { name: "person" })
    ]),
    (state.isOpen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_ctx.notificationItems.length > 0)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.notificationItems, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `notification-item-${index}`,
                      class: "dropdown-body__content-item-container"
                    }, [
                      _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)(item.status)), 1),
                      _createElementVNode("div", {
                        class: "dropdown-body__delete-icon",
                        onClick: ($event: any) => (onClickMenuItem(item))
                      }, _toDisplayString('X'), 8, _hoisted_6)
                    ]))
                  }), 128))
                : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(t)('通知情報はありません')), 1),
                    _createElementVNode("div", {
                      class: "dropdown-body__delete-icon",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (onClickMenuItem({ requestId: '', status: '通知情報はありません', actionName: 'non' })))
                    }, _toDisplayString('X'))
                  ]))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})